import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()

export const actions = {
  getCurrentUrl: (currentUrl) => {
    return {
      currentUrl,
      type: 'getCurrentUrl'
    }
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  'getCurrentUrl': (state, action) => {
    return {
      ...state,
      currentUrl: action.currentUrl
    }
  },
}

const initialState = {
  currentUrl: ''
}

export function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  let nextState =  handler ? handler(state, action) : {...state}
  nextState = reducerHandler(initialState)(nextState, action)
  return nextState
}





// WEBPACK FOOTER //
// ./modules/qrCode/redux.js